import { VerticalAlignTopOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import styles from './ScrollToTop.module.scss';

interface ScrollToTopProps {
  scrollContainer: HTMLElement | null;
  threshold?: number;
}

export function ScrollToTop({ scrollContainer, threshold = 280 }: ScrollToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!scrollContainer) {
      setVisible(false);
      return;
    }

    const onScroll = () => {
      setVisible(scrollContainer.scrollTop > threshold);
    };

    onScroll();
    scrollContainer.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      scrollContainer.removeEventListener('scroll', onScroll);
    };
  }, [scrollContainer, threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      className={styles.button}
      aria-label="Scroll to top"
      onClick={() => scrollContainer?.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <VerticalAlignTopOutlined />
    </button>
  );
}
